import { scaleUp } from '@styles/animations'
import { styled } from '@styles/theme'

export const sideMenuStyles = {
	SideMenu: styled('div', {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
		position: 'fixed',
		maxWidth: '277px',
		minWidth: '277px',
		width: '100%',
		background: '$neutral10',
		paddingTop: '112px',
		height: '100vh',
		bottom: 0,
		zIndex: 100,
		animation: `${scaleUp} 150ms`,

		'@sm': {
			maxWidth: '277px',
		},

		variants: {
			isOpened: {
				false: {
					maxWidth: '101px',
					minWidth: '101px',
				},
			},
		},
	}),

	OverlaySideMenu: styled('div', {
		position: 'fixed',
		minHeight: '100%',
		width: '100%',
		background: '$modalOverlay',
		zIndex: '100',

		variants: {
			open: {
				false: {
					display: 'none',
				},
			},
		},
	}),
}
